function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "28",
  height: "28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.25 14l-2.917-2.917 2.917-2.916",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M16.536 24.326l-1.96-1.307a1.038 1.038 0 00-1.151 0l-1.961 1.307a1.038 1.038 0 01-1.15 0l-1.96-1.308a1.038 1.038 0 00-1.151 0l-.924.616a1.037 1.037 0 01-1.612-.862V5.574c0-1.145.928-2.074 2.074-2.074h14.518c1.146 0 2.074.929 2.074 2.074v17.198c0 .829-.923 1.322-1.612.864l-.924-.617a1.038 1.038 0 00-1.15 0l-1.961 1.307a1.038 1.038 0 01-1.15 0z",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.333 11.083h6.125a3.208 3.208 0 010 6.417H14",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));